<main>
    <div class="container">
        <div class="row">
            <div class="col">
                <h1 class="logo"><img src="../../../assets/soteam.png" alt="Soteam"></h1>

                <mat-card>
                    <mat-card-header>
                        <mat-card-title>Log In</mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <form name="form" (ngSubmit)="onLogin(f)" #f="ngForm" class="text-left">

                            <mat-form-field class="help-width-100p">
                                <input matInput
                                       type="email"
                                       name="email"
                                       #email="ngModel"
                                       email
                                       ngModel
                                       required
                                       autocomplete="username email"
                                       placeholder="E-mail">
                                <mat-error *ngIf="email.hasError('email') && !email.hasError('required')">
                                    Please enter a valid e-mail address
                                </mat-error>
                                <mat-error *ngIf="email.hasError('required')">
                                    E-mail is <strong>required</strong>
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="help-width-100p">
                                <input matInput
                                       type="password"
                                       name="password"
                                       #password="ngModel"
                                       ngModel
                                       required
                                       minlength="6"
                                       autocomplete="current-password"
                                       placeholder="Password">
                                <mat-error *ngIf="password.invalid && (password.dirty || password.touched)">
                                    <span *ngIf="password.hasError('required')">Password is required. </span>
                                    <span *ngIf="password.hasError('minlength')">Password must be at least 6 characters long. </span>
                                </mat-error>
                            </mat-form-field>

                            <button type="submit"
                                    mat-raised-button color="primary"
                                    [disabled]="f.form.invalid">Log In
                            </button>
                            <a routerLink="/password-forgot" class="link link--btn">Forgot your password?</a>
                        </form>
                    </mat-card-content>
                </mat-card>
                <p>Don't have an account? <a routerLink="/register" class="btn-sign-up" mat-stroked-button color="primary">Sign Up</a></p>
                <p><a href="https://so.team" class="link" target="_blank">About Soteam</a></p>
            </div>
        </div>
    </div>
</main>
